import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/app';

// Render the React component in DOM.
ReactDOM.render(
  <App />,
  document.getElementById('main'),
);
